import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'

const PesquisaNaoRealizada = () => {
    const [ficha, setFicha] = useState({ buscaChave: "", buscaValor: "", dados: [] })
    const [fiscais, setFiscais] = useState()

    useEffect(() => {
        const url = '/api/user/getFiscais'
        axios(url)
            .then(resp => {
                setFiscais(resp.data)
            })
            .catch(error => {
                alert(error.response.data)
            }
            )
    }, [])

    const updateField = (e) => {
        const { name, value } = e.target
        let update = { ...ficha }
        update[name] = value
        setFicha(update)
        if (name === "buscaValor") {
            const url = '/api/rotaNaoRealizada/getAll'
            axios.post(url, { chave: ficha.buscaChave, valor: value })
                .then(resp => {
                    setFicha((prevState) => ({ ...prevState, dados: resp.data }))
                })
                .catch(error => {
                    alert(error.response.data)
                }
                )
        }
    }

    const styles = {
        principal: {
            display: "inline-grid",
            textAlign: "left", color: "#484848", marginTop: "2vh"
        },
        input: {
            width: "80vw", backgroundColor: "#00000000", border: "1px solid #00000029",
            borderRadius: "5px", minHeight: "5px"
        }
    }

    return (
        <>
            <div style={{ textAlign: "left", marginLeft: "5vw" }}>
                <div style={styles.principal}>
                    <div>Buscar por:</div>
                    <select type="text" style={{ ...styles.input, width: "18vw" }} name="buscaChave"
                        onChange={e => updateField(e)} >
                        <option value=""></option>
                        <option value="Fiscal">Fiscal</option>
                        <option value="Tipo">Tipo</option>
                        <option value="Data">Data</option>
                    </select>
                </div>
                {RenderFiltro()}
            </div>
            <div style={{ margin: "auto", textAlign: "center", width: "90vw" }}>
                <table className="table mt-4">
                    <thead>
                        <tr>
                            <th>ESTABELECIMENTO</th>
                            <th>FISCAL</th>
                            <th>SITUAÇÃO</th>
                            <th>DATA</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {RenderTable()}
                    </tbody>
                </table>
            </div>
        </>
    )

    function RenderFiltro() {
        if (ficha.buscaChave === "Fiscal") {
            return (
                <div style={{ ...styles.principal, marginLeft: "2vw" }}>
                    <div>Fiscal:</div>
                    <select type="text" style={{ ...styles.input, width: "18vw" }} name="buscaValor"
                        onChange={e => updateField(e)} >
                        <option value=""></option>
                        {RenderFiscais()}
                    </select>
                </div>
            )
        }
        else if (ficha.buscaChave === "Tipo") {
            return (
                <div style={{ ...styles.principal, marginLeft: "2vw" }}>
                    <div>Tipo:</div>
                    <select type="text" style={{ ...styles.input, width: "18vw" }} name="buscaValor"
                        onChange={e => updateField(e)} >
                        <option value=""></option>
                        <option value="Fechado">Fechado</option>
                        <option value="Desativado">Desativado</option>
                    </select>
                </div>
            )
        }
        else if (ficha.buscaChave === "Data") {
            return (
                <div style={{ ...styles.principal, marginLeft: "2vw" }}>
                    <div>Data:</div>
                    <input type="date" style={{ ...styles.input, width: "18vw" }}
                        name="buscaValor" onChange={e => updateField(e)} />
                </div>
            )
        }
    }

    function RenderFiscais() {
        let select = []
        fiscais.map(el => {
            select.push(<option value={el.nome}>{el.nome}</option>)
        })
        return select
    }

    function RenderTable() {
        return ficha.dados.map(el => {
            const dia = el.data.slice(8, 10)
            const mes = el.data.slice(5, 7)
            const ano = el.data.slice(0, 4)
            const data = dia + "/" + mes + "/" + ano
            return (
                <tr key={el._id}>
                    <td>{el.estabelecimento || ""}</td>
                    <td>{el.user || ""}</td>
                    <td>{el.situacao || ""}</td>
                    <td>{data || ""}</td>
                    <td>
                        <Link to={`/certidaoRotaFechada/${el._id}`} target="_blank">
                            <button className="btn btn-warning">Abrir</button>
                        </Link>
                    </td>
                </tr>
            )
        })
    }
}

export default PesquisaNaoRealizada